import React, { useState, useEffect } from "react";
import { Input, Form } from "antd";
import { useParams } from "react-router-dom";

import TranslationModal from "../../modals/TranslationModal";
import GenericTable from "../../GeneralTable/GenericTable";
import { EditingProps, LoadingState, MediaItem } from "../../../types/types";

import CodeFormModal from "./CodeFormModal";
import ExportModal from "./ExportModal";
import RecursiveCodeTable from "./RecursiveCodeTable";
import CodeTable from "./CodeTable";
import { fetchCodes, handleSubmitCode } from "../../../utils/codeHelpers";

const { Search } = Input;

const CodesMain: React.FC = () => {
  const { id: projectId } = useParams<{ id: string }>();

  const [tableData, setTableData] = useState<MediaItem[]>([]);
  const [showAddCodeModal, setShowAddCodeModal] = useState(false);
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [selectionType, setSelectionType] = useState<"checkbox">("checkbox");

  const [loading, setLoading] = useState<LoadingState>({
    codes: false,
    submit: false,
  });

  const [editing, setEditing] = useState<EditingProps>({
    id: "",
    isEditing: false,
  });

  useEffect(() => {
    if (projectId) {
      fetchCodes(projectId, setLoading, setTableData);
    }
  }, [projectId]);

  const handleSubmit = () => {
    if (!projectId) return;

    handleSubmitCode({
      editing,
      form,
      projectId,
      setLoading,
      setShowAddCodeModal,
      fetchCodes: () => fetchCodes(projectId, setLoading, setTableData),
    });
  };

  return (
    <div className="codesPageContainer">
      <CodeFormModal
        visible={showAddCodeModal}
        onCancel={() => setShowAddCodeModal(false)}
        onSubmit={handleSubmit}
        form={form}
        loading={loading.submit}
        // editing={editing}
      />

      <ExportModal
        visible={exportModalVisible}
        onCancel={() => setExportModalVisible(false)}
        form={form}
        loading={loading.submit}
        onSubmit={handleSubmit}
      />

      <RecursiveCodeTable />
    </div>
  );
};

export default CodesMain;
